var _rect, _rect2, _rect3, _rect4, _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgQuarter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.64355,
    y: 6.5,
    width: 27,
    height: 27,
    stroke: "#737478",
    strokeDasharray: "5 5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.64355,
    y: 30.5,
    width: 5,
    height: 5,
    fill: "white",
    stroke: "#2C3038"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30.6436,
    y: 30.5,
    width: 5,
    height: 5,
    fill: "white",
    stroke: "#2C3038"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4.64355,
    y: 4.5,
    width: 5,
    height: 5,
    fill: "white",
    stroke: "#2C3038"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_927_10504",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1436 6H34.1436V21H19.1436V6Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1436 6H34.1436V21H19.1436V6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1436 21H17.1436V23H19.1436V21ZM34.1436 19H19.1436V23H34.1436V19ZM21.1436 21V6H17.1436V21H21.1436Z",
    fill: "#F87B0E",
    mask: "url(#path-5-inside-1_927_10504)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgQuarter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/quarter.25a68ef4b4a4a382982c44d08b888607.svg";